<template>
  <div class="contentBox">
    <div class="title">All-Star system</div>
    <div class="functionArea">
      <!-- 工具类应用 -->
      <div
        class="externAppsBox"
        v-if="!isEmpty(this.externApps) && servicePage"
      >
        <div
          v-for="(item, index) in externApps"
          :key="index"
          style="cursor: pointer; width: 25px; height: 25px"
          @click="openWindow(item.entry)"
          :id="item.entry"
        >
          <template v-if="!isEmpty(item.icon)">
            <img :src="item.icon" alt="" width="25px" height="25px" />
          </template>
          <template v-else>
            <span>{{ item.appName.substring(0, 3) }}</span>
          </template>
        </div>
      </div>
      <el-divider
        direction="vertical"
        v-if="!isEmpty(this.externApps) && servicePage"
      ></el-divider>
      <!-- 用户相关操作 -->
      <div class="userOperatesBox">
        <el-dropdown @command="userHandler">
          <div class="userBox">
            <div class="iconBox">
              <img src="../assets/person.png" alt="" />
            </div>
            <div class="usernameBox">
              <span class="userName">{{
                isEmpty(this.currentUser.nickname)
                  ? this.currentUser.username
                  : this.currentUser.nickname
              }}</span>
            </div>
            <div>
              <i class="el-icon-caret-bottom" style="color: #cccccc"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="hasAsPermission"
                command="userInfo"
                id="userInfo"
                ><i class="el-icon-user" />{{
                  $t("button.userInfo")
                }}</el-dropdown-item
              >
              <el-dropdown-item
                v-if="hasAsPermission"
                command="passwordChange"
                id="passwordChange"
                ><i class="el-icon-lock" />{{
                  $t("button.passwordChange")
                }}</el-dropdown-item
              >

              <el-dropdown-item
                v-if="hasAsPermission"
                command="messageCenter"
                id="messageCenter"
                ><i class="el-icon-message" />{{
                  $t("button.messageCenter")
                }}</el-dropdown-item
              >
              <el-dropdown-item
                v-if="hasServicePage"
                command="pageChange"
                id="pageChange"
                ><i class="el-icon-setting" />{{
                  pageStatu
                    ? $t("button.toManagePage")
                    : $t("button.toServicePage")
                }}</el-dropdown-item
              >
              <el-dropdown-item
                v-if="hasAsPermission"
                command="versionInfo"
                id="versionInfo"
                ><i class="iconfont icon-tishi" />{{
                  $t("appsVersion.systemVersion")
                }}</el-dropdown-item
              >
              <el-dropdown-item command="exit" id="logout"
                ><i class="iconfont icon-tuichu" />{{
                  $t("button.logout")
                }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </div>
        </el-dropdown>
      </div>
      <el-divider direction="vertical"></el-divider>
      <!-- 收件箱 -->
      <div class="asMessageBox" @click="openMessageBox">
        <el-badge :value="unReadMessageCount">
          <span style="color: #606266"><i class="el-icon-message"></i></span>
        </el-badge>
      </div>
      <el-divider direction="vertical"></el-divider>
      <!-- 语言切换 -->
      <div class="languageChangeBox">
        <el-dropdown @command="languageHandler" id="languageChange">
          <div class="languageItemBox">
            <i
              class="iconfont icon-ziranyuyanchuli"
              style="margin-right: 10px"
            ></i>
            <span>{{
              languageList.find((item) => item.code == currentLanguage).name
            }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in languageList"
              :key="index"
              :command="item.code"
              :id="item.code"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  align-content: center;
                  justify-content: flex-start;
                "
              >
                <!-- <svg
                  width="1.5em"
                  height="1.5em"
                  class="icon"
                  aria-hidden="true"
                  style="margin-right: 5px"
                >
                  <use xlink:href="# icon-zhongguoguoqi"></use>
                </svg> -->
                {{ item.name }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <template v-if="!partner && servicePage">
        <template
          v-if="
            !storeHiddenApp
              .map((item) => item.toLowerCase())
              .includes(currentAppName.toLowerCase()) &&
            !isEmpty(this.customers)
          "
        >
          <!-- <template> -->
          <el-divider direction="vertical"></el-divider>
          <!-- 门店选择 -->
          <div class="selectBox">
            <div>
              <i class="iconfont icon-mendian" style="margin-right: 6px"></i>
            </div>
            <div class="selectDiv">
              <el-select
                id="storeSelect"
                class="selectCom"
                v-model="currentStore"
                :popper-append-to-body="false"
                popper-class="topHeaderCustomerOption"
                placeholder=""
                @change="terminalChange"
                size="small"
                filterable
                :clearable="canClearStores()"
              >
                <el-option
                  v-for="item in currentCustomerStores"
                  :key="item.id"
                  :label="getLabel(item.terminal, item.terminalName)"
                  :value="item.terminal"
                  :id="`${item.org}.${item.terminal}`"
                >
                </el-option
              ></el-select>
            </div>
          </div>
        </template>
        <el-divider direction="vertical"></el-divider>
        <!-- 客户选择 -->
        <div class="selectBox" v-if="!isEmpty(this.customers)">
          <div>
            <i class="iconfont icon-zuzhijiagou" style="margin-right: 6px"></i>
          </div>
          <div class="selectDiv">
            <el-select
              id="customerSelect"
              class="selectCom"
              v-model="currentCustomer"
              :popper-append-to-body="false"
              popper-class="topHeaderCustomerOption"
              placeholder=" "
              @change="orgChange"
              size="small"
              filterable
            >
              <el-option
                v-for="item in customers"
                :key="item.orgCode"
                :label="getLabel(item.orgCode, item.orgName)"
                :value="item.orgCode"
                :id="item.orgCode"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </template>
    </div>

    <!-- message box -->
    <el-drawer
      :visible.sync="messageBoxOpenStatus"
      direction="rtl"
      :modal="false"
      size="500px"
      :destroy-on-close="true"
      :before-close="messageBoxCloseHandle"
    >
      <!-- title -->
      <template v-slot:title>
        <div class="titleClass">
          <div>
            {{ $t("messageBox.title") }}
          </div>
          <div>
            <el-button
              class="readAllBtn"
              size="small"
              @click="readAllMessage()"
            >
              {{ $t("button.allRead") }}</el-button
            >
          </div>
        </div>
      </template>
      <!-- body -->
      <div class="messageTableBox">
        <messageTable ref="messageTable"></messageTable>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { isEmpty, dataToString } from "@/utils/utils";
import { isEqual } from "lodash";
import messageTable from "@/components/messageTable";
export default {
  props: ["externApps", "languageList", "orgDomains"],
  components: { messageTable },
  watch: {
    customers(newVal, oldVal) {
      if (!isEqual(newVal, oldVal)) {
        this.orgTerminalInit();
      }
    },
    // 门店数据变更监听
    globalCurrentStore(newVal) {
      this.currentStore = newVal;
    },
  },
  computed: {
    pageStatu() {
      // 页面状态  为true 表示当前在业务页面
      return this.$actions.getGlobalState("servicePage");
    },
    hasServicePage() {
      return this.$store.state.config.hasServicePage;
    },
    customers() {
      return this.$actions.getGlobalState("commonData").customer;
    },
    globalCurrentCustomer() {
      return this.$actions.getGlobalState("currentCustomer");
    },
    globalCurrentLanguage() {
      return this.$actions.getGlobalState("currentLanguage");
    },
    currentLanguage() {
      return this.globalCurrentLanguage;
    },
    currentUser() {
      return this.$actions.getGlobalState("currentUser");
    },
    currentAppName() {
      return this.$actions.getGlobalState("currentAppName");
    },
    globalCurrentStore() {
      return this.$actions.getGlobalState("currentStore");
    },
    storeHiddenApp() {
      return window.HS_CONFIG.storeHiddenApp;
    },
    currentCustomerStores() {
      if (this.currentCustomer) {
        if (!isEmpty(this.$actions.getGlobalState("commonData").data)) {
          return (
            this.$actions
              .getGlobalState("commonData")
              .data.find(
                (item) => item.customer.orgCode == this.currentCustomer
              )?.terminals ?? []
          );
        }
        return [];
      }
      return [];
    },
    partner() {
      return window.HS_CONFIG.partner;
    },
    servicePage() {
      return this.$actions.getGlobalState("servicePage");
    },
    hasAsPermission() {
      return this.$store.state.config.hasAsPermission;
    },
    unReadMessageCount() {
      return this.$store.state.wsStore.count == 0
        ? null
        : this.$store.state.wsStore.count;
    },
  },
  data() {
    return {
      currentCustomer: "",
      currentStore: "",
      messageBoxOpenStatus: false,
      scrollDisabled: true,
    };
  },
  mounted() {
    console.log(this.$actions.getGlobalState());
    // 异步处理门店组织 语言初始化
    // window.setTimeout(() => {
    this.orgTerminalInit();
    // 选择默认语言
    if (this.globalCurrentLanguage) {
      return;
    } else {
      this.$actions.setGlobalState({
        currentLanguage: window.HS_CONFIG.DEFAULT_LANGUAGE,
      });
    }
    // }, 0);
  },
  methods: {
    // dataToString,
    isEmpty,
    orgTerminalInit() {
      //俩全空才选  但凡有一个有值 就不管
      if (
        isEmpty(this.globalCurrentCustomer) &&
        isEmpty(this.globalCurrentStore)
      ) {
        // 如果俩都为空  俩都给选上
        if (!isEmpty(this.customers)) {
          this.currentCustomer = this.customers[0].orgCode;
          this.orgChange(this.currentCustomer);
        }
        if (!isEmpty(this.currentCustomerStores)) {
          this.currentStore = this.currentCustomerStores[0].terminal;
          this.terminalChange(this.currentStore);
        }
      } else {
        this.currentCustomer = this.globalCurrentCustomer;
        this.currentStore = this.globalCurrentStore;
      }
    },
    orgChange(data) {
      this.currentCustomer = data;
      //  有门店默认选中第一个，没有不选
      // this.currentStore = this.currentCustomerStores[0]
      //   ? this.currentCustomerStores[0].terminal
      //   : "";
      this.currentStore = "";
      console.log(this.currentStore);
      window.setTimeout(() => {
        this.$actions.setGlobalState({
          currentCustomer: data,
          currentStore: this.currentStore,
        });
      }, 0);
    },
    terminalChange(data) {
      //门店修改  触发方法
      console.log(data);
      window.setTimeout(() => {
        this.$actions.setGlobalState({
          currentStore: data,
        });
      }, 0);
    },
    languageHandler(data) {
      window.setTimeout(() => {
        this.$actions.setGlobalState({
          currentLanguage: data,
        });
      }, 0);
    },
    userHandler(data) {
      this.$emit("pageChange", data);
    },
    getLabel(code, name) {
      return name + "(" + code + ")";
    },
    openWindow(entry) {
      let url = entry;
      let accessToken = this.$actions.getGlobalState("accessToken");
      url += "?token=" + accessToken;
      window.open(url);
    },
    canClearStores() {
      console.log(this.orgDomains);
      if (this.orgDomains[0] == "**") {
        //当前超级管理员   都可以关
        return true;
      } else {
        if (!isEmpty(this.orgDomains)) {
          let orgCodes = this.orgDomains.map((item) => item.replace(".**", ""));
          if (orgCodes.includes(this.currentCustomer)) {
            return true;
          }
        }
        return false;
      }
    },

    // 收件箱相关逻辑
    openMessageBox() {
      this.messageBoxOpenStatus = !this.messageBoxOpenStatus;
      console.log(this.messageBoxOpenStatus);
      this.$nextTick(() => {
        this.$refs.messageTable.searchFun();
      });
    },

    messageBoxCloseHandle(done) {
      console.log("我关闭了");
      done();
    },
    readAllMessage() {
      return new Promise((resolve, reject) => {
        this.$httpList
          .readAllMessage()
          .then((res) => {
            if (res.resultCode == 1001) {
              this.$notify.success(this.$t("messageBoxPromptMessage.allRead"));
              this.$refs.messageTable.updateTableData();
              resolve(res);
            }
          })
          .catch((err) => reject(err));
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .messageTableBox {
  height: calc(100vh - 90px);
  overflow: hidden;
}
.contentBox {
  // background: wheat;
  height: 100%;
  width: 100%;
  border-bottom: 1px solid rgb(217, 222, 226);
  display: flex;
  padding-right: 16px;
  min-width: 700px;
  .title {
    width: 178px;
    min-width: 178px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    border-right: 1px solid rgb(217, 222, 226);
  }
  .functionArea {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    align-content: center;
    flex: 1;
    .userBox {
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: center;
      padding: 7px;
      .iconBox {
        margin-right: 7px;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        img {
          height: 22px;
          width: 22px;
        }
      }
      .usernameBox {
        margin-right: 5px;
      }
    }
    .selectBox {
      // 修改阻止门店下拉宽度
      flex-grow: 0.09;
      display: flex;
      align-items: center;
      ::v-deep .el-input__inner {
        text-overflow: ellipsis;
      }
      .selectDiv {
        flex-grow: 1;
        .selectCom {
          width: 100% !important;
        }
      }
    }
    .externAppsBox {
      margin-right: 7px;
      display: flex;
      align-items: center;
      align-content: center;
    }
  }
  .languageChangeBox {
    margin: 0 10px;
    min-width: 100px;
    .languageItemBox {
      padding: 7px;
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: center;
      .languageIcon {
        margin-right: 7px;
      }
    }
  }
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #303133;
  display: flex;
  margin-bottom: 32px;
  padding: 10px;
  border-bottom: 1px solid #cccccc;
  height: 29px;
}
.readAllBtn {
  border-radius: 8px;
  color: #015ac5;
  border-color: #015ac5;
  background-color: #ffffff;
}
.titleClass {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}
</style>
